import { faDatabase } from '@fortawesome/free-solid-svg-icons'

// Импорт иконок
import groups_icon from '../../../img/groups.svg';
import documents_icon from '../../../img/documents.svg';
import staff_icon from '../../../img/staff.svg';
import base_icon from '../../../img/base.svg';
import passport_icon from '../../../img/passport.svg';
import zvit_icon from '../../../img/zvit.svg';
import parents_icon from '../../../img/parents.svg';
import orders_icon from '../../../img/orders.svg';
import statistic_icon from '../../../img/statistic.svg';
import location_icon from '../../../img/location.svg';
import collection_icon from '../../../img/collection-fill.svg';
import info_icon from '../../../img/info-circle-fill.svg'
import childrens_icon from '../../../img/person-lines-fill.svg';
import sms_icon from '../../../img/send-check-fill.svg';
import messages_icon from '../../../img/envelope-paper-fill.svg'
import personalcab_icon from '../../../img/person-hearts.svg';

import diagram_3_icon from '../../../img/diagram-3-fill.svg';
import invite_planned_icon from '../../../img/envelopes-bulk-solid.svg'


  const title = '';

    const   rightPossible = {
    isPossibleAddGroup: true,
    dictionaryEdit:{
      docs: true,
      positions: true,
      years: true,
      staffRulles: true
    },
    mode:{
      application: "edit"
    }
  }

  const menuItems = [
    {
        "id": "users",
        "label": "Користувачі",
        "icon": staff_icon
    },
    {
        "id": "statistica",
        "label": "Статистика",
        "icon": statistic_icon,
        hasDropdown: true
    },
    {
        "id": "orderlist",
        "label": "Заявки",
        "icon": orders_icon,
        hasDropdown: true
    },
//    {
//        id: 'inviteplans',
//        label: 'Надсилання запрошень',
//        icon: invite_planned_icon,
//        hasDropdown: false
//    },
    {
        "id": "infoApprovedBenefits",
        "label": "Інфо",
        "icon": info_icon
    },
    {
        "id": "newsAdmin",
        "label": "Новини порталу",
        "icon": info_icon
    },
    {
        "id": "showChildren",
        "label": "Діти",
        "icon": childrens_icon
    },
    {
        "id": "kindergartens",
        "label": "Обрати ЗДО",
        "icon": passport_icon,
        hasDropdown: true
    },
    {
        "id": "messages",
        "label": "Повідомлення",
        "icon": messages_icon
    },
    {
        "id": "checkRegKyiv",
        "label": "Перевірка реєстрації",
        "icon": parents_icon
    },
    {
        "id": "reports",
        "label": "Звітність",
        "icon": zvit_icon
    },
    {
        "id": "smsnotif",
        "label": "СМС",
        "icon": sms_icon
    },
    {
      id: 'dictionary',
      label: 'Довідники',
      icon: collection_icon,
      hasDropdown: true,
      href: '#',
      badge: null
    }
  ];



  const level2Items = {
          "statistica":[
                {
                  "id": "queue",
                  "label": "Заявки"
                },
                {
                  "id": "child",
                  "label": "Діти у садочках"
                },
                {
                  "id": "groups",
                  "label": "Групи поточні"
                },
                {
                  "id": "groups_arch",
                  "label": "Групи архівні"
                },
                {
                  "id": "invites",
                  "label": "Запрошення"
                },
                {
                  "id": "attends",
                  "label": "Відвідування"
                },
                {
                  "id": "bfn",
                  "label": "БФН"
                },
                {
                  "id": "benefits",
                  "label": "Пільги"
                },
                {
                  "id": "queue_kg",
                  "label": "Черга по садочкам"
                },
                {
                  "id": "staff_zdo",
                  "label": "Штатний розпис і працівники"
                }
      ],
    "dictionary":[
           {
            id: 'dict_docs',
            label: 'Типи документів',
            icon: groups_icon,
            hasDropdown: true,
            href: '#',
            badge: null
        },
        {
            id: 'proffessions',
            label: 'Найменування посад',
            icon: groups_icon,
            hasDropdown: true,
            href: '#',
            badge: null
        },
        {
            id: 'years_dict',
            label: 'Навчальний  рік',
            icon: groups_icon,
            hasDropdown: true,
            href: '#',
            badge: null
        },
        {
            "id": "staffRulles",
            "label": "Правила ШОД",
            "icon": base_icon
        },
        {
            "id": "newsCategories",
            "label": "категорії новин",
            "icon": base_icon
        },
        {
            "id": "kitchen",
            "label": "Кухня",
            "icon": ""
        }
        
    ],
    "kindergartens":[
      {
          "id": "addKindergarten",
          "label": "Додати ЗДО",
          "icon": passport_icon
      },
      {
          "id": "editKindergarten",
          "label": "Перелік ЗДО",
          "icon": passport_icon
      }
    ],
    "base":[
        {
            id: 'base_bda',
            label: 'Приміщення',
            icon: groups_icon,
            hasDropdown: true,
            href: '#',
            badge: null
        },
        {
            id: 'base_pc',
            label: 'Компьютери',
            icon: groups_icon,
            hasDropdown: true,
            href: '#',
            badge: null
        }
    ],
    "orderlist":[
      {
        id: 'orderlist',
        label: 'Все',
      },
      {
        id: 'orderNew',
        label: 'Створити заявку',
        icon: groups_icon,
        hasDropdown: true,
        href: '#',
        badge: null
      },
      {
        id: 'emailchange',
        label: 'Змінити пошту',
        icon: groups_icon,
        hasDropdown: true,
        href: '#',
        badge: null
      },
      {
        id: 'firstDate',
        label: 'Змінити першу дату',
        icon: groups_icon,
        hasDropdown: true,
        href: '#',
        badge: null
      }
    ]
  }

  const additionalLinks = [
    
    {
      id: 'all-kindergartens',
      label: 'Всі садочки',
      icon: location_icon,
      href: '/kglist'
    },
    {
      id: 'statistics',
      label: 'Статистика публічна',
      icon: statistic_icon,
      href: '/publicstatistics'
    },
    {
      id: 'statistics',
      label: 'Мій кабінет батьків',
      icon: personalcab_icon,
      href: '/cabinet',
      active: false
    }
  ];

  const cabinetName = "кабінет адміністратора ДОН";

  const Menu = { menuItems, level2Items, additionalLinks, title, cabinetName, rightPossible };

  export {menuItems, level2Items, additionalLinks, title};

  export default Menu;